export default __webpack_public_path__ + "static/media/image_profile.19491bac.jpg";